import { render, staticRenderFns } from "./VaButton.demo.vue?vue&type=template&id=436883b2&"
import script from "./VaButton.demo.vue?vue&type=script&lang=js&"
export * from "./VaButton.demo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports